import { Component } from 'preact'
import classnames from 'classnames'
import Search from './Search'
import { getInsidedData } from '@insided/destination/utils/insidedDataStorage'

interface Props extends SearchScope {
  isUserGuest: boolean
}

function getCategoryId() {
  if (typeof window === 'undefined') return null
  return getInsidedData('content').category.id
}

export default class SearchForm extends Component<Props> {
  render() {
    const { isUserGuest, isFederatedSkilljarSearch, isFederatedSalesforceSearch, isFederatedFreshdeskSearch } =
      this.props
    return (
      <form method='get' action='/search/index'>
        <div className={classnames('searchbox', 'searchbox--large', 'qa-search-area')}>
          <div className={classnames('searchbox__input', 'algolia-search--forum', 'qa-menu-search-input')}>
            <Search
              isUserGuest={isUserGuest}
              isFederatedSalesforceSearch={isFederatedSalesforceSearch}
              isFederatedSkilljarSearch={isFederatedSkilljarSearch}
              isFederatedFreshdeskSearch={isFederatedFreshdeskSearch}
              category={getCategoryId() ?? undefined}
              isParentCategory={false} // TODO implement this and isParentCategory when extending this feature to category page
            />
          </div>
        </div>
      </form>
    )
  }
}
